var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"elevation-0 mx-3"},[_c('v-card-title',{staticClass:"body-2"},[_c('v-icon',{staticClass:"pr-2"},[_vm._v(" error_outline ")]),_vm._v(" Error loading data. Please try again later or "),_c('a',{staticClass:"pl-1",attrs:{"href":"mailto:tech@oao.freshdesk.com","target":"_blank"}},[_vm._v(" contact us ")]),_vm._v(". ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }